import { Routes, Route } from "react-router-dom";

import { PublicLayout } from "./layouts/PublicLayout";
import { AuthLayout } from "./layouts/AuthLayout";
import { AppLayout } from "./layouts/AppLayout";


import { Login } from "./features/auth/Login";
import { Register } from "./features/auth/Register";
import { ForgotPassword } from "./features/auth/ForgotPassword";
import { Verification } from "./features/auth/Verification";


import { Dashboard } from "./features/dashboard/Dashboard";
import { UserManage } from "./features/dashboard/ManageDashboard/UserManage";
import { ManageCourse } from "./features/dashboard/instructor/ManageCourse";
import { CourseManage } from "./features/courses/CourseManage";

import { CourseContent } from "./features/dashboard/ManageDashboard/CourseContent";
import { ViewCourse } from "./features/dashboard/admin/ViewCourse";
import { MyCourse } from "./features/dashboard/instructor/MyCourse";

import StudentLayout from "./layouts/StudentLayout";
import { UserDashboard } from "./features/dashboard/user/UserDashboard";
import Cart from "./features/dashboard/user/Cart";
import UserCourses from "./features/dashboard/user/UserCourses";
import Profile from "./features/dashboard/user/Profile";
import CourseView from "./features/dashboard/user/CourseView";
import { InsProfile } from "./features/dashboard/instructor/InsProfile";
import { BasicInformation } from "./features/dashboard/instructor/BasicInformation";
import { Experience } from "./features/dashboard/instructor/Experience";
import { Education } from "./features/dashboard/instructor/Education";
import { SocialLinks } from "./features/dashboard/instructor/SocialLinks";
import { AboutYou } from "./features/dashboard/instructor/AboutYou";
import { AccountDetails } from "./features/dashboard/instructor/AccountDetails";
import { MyProfile } from "./features/dashboard/instructor/MyProfile";
import { Courses } from "./features/dashboard/admin/Courses";
import { CoursePricing } from "./features/dashboard/admin/CoursePricing";
import { SpecialDiscount } from "./features/dashboard/admin/SpecialDiscount";
import { ViewUser } from "./features/dashboard/admin/ViewUser";
import FetchMessages from "./features/Messages";
import { Carts } from "./features/Carts";
import { Orders } from "./features/Orders";
import { NotFound } from "./components/common/NotFound";
import { Home } from "./features/public/Landing/Home";
import {Notifications} from "./features/Notifications";
import { UserVerification } from "./features/auth/UserVerification";
import { About } from "./features/public/About/About";
import { CoursesHome } from "./features/public/Courses/CoursesHome";
import { InstructorLayout } from "./layouts/InstructorLayout";
import { InstructorDashboard } from "./features/dashboard/instructor/InstructorDashboard";
import { OrderCourses } from "./features/dashboard/instructor/OrderCourses";




export const Routers = () => {
    return (
        <Routes>
            {/* PUBLIC */}
            <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/courses" element={<CoursesHome />} />
            </Route>

            {/* AUTH (ONLY FOR NOT LOGGED USERS) */}
            <Route element={<AuthLayout />}>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/verify" element={<UserVerification />} />
            </Route>

            {/* APP (ROLE BASED) */}
            <Route path="/app" element={<AppLayout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="users" element={<UserManage />} />
                <Route path="view-user" element={<ViewUser />} />

                <Route path="profile" element={<InsProfile />} />
                <Route path="department/create" element={<CourseManage />} />
                <Route path="courses" element={<Courses />} />
                <Route path="course-view" element={<ViewCourse />} />
                <Route path="course-pricing" element={<CoursePricing />} />
                <Route path="carts" element={<Carts />} />
                <Route path="orders" element={<Orders />} />
               
                <Route path="notifications" element={<Notifications />} />

                {/* Instructor pages */}
                <Route path="mycourse" element={<MyCourse />} />
                <Route path="managecourse/:id" element={<ManageCourse />} />
                <Route path="communications" element={<FetchMessages />} />


                <Route path="special-discount" element={<SpecialDiscount />} />

                <Route path="course-content" element={<CourseContent />} />
                {/* <Route path="create" element={<CreateUser />} /> */}
                <Route path="verify" element={<Verification />} />

            </Route>

            {/* Instructor Routers */}
            <Route path="/instructor" element={<InstructorLayout/>}>
                <Route path="dashboard" element={<InstructorDashboard />} />
                <Route path="mycourse" element={<MyCourse />} />
                <Route path="managecourse/:id" element={<ManageCourse />} />
                <Route path="orders" element={<OrderCourses />} />
                <Route path="communications" element={<FetchMessages />} />
                <Route path="notifications" element={<Notifications />} />
                
                <Route path="my" element={<InsProfile />}>
                    <Route path="profile" element={<MyProfile />} />
                    <Route path="basic-info" element={<BasicInformation />} />
                    <Route path="experience" element={<Experience />} />
                    <Route path="education" element={<Education />} />
                    <Route path="social-links" element={<SocialLinks />} />
                    <Route path="about" element={<AboutYou />} />
                    <Route path="account" element={<AccountDetails />} />
                </Route>
            </Route>


             {/* student Routers */}
            <Route path="/learner" element={<StudentLayout />}>
                <Route path="courses" element={<UserDashboard />} />
                <Route path="courses/:courseId" element={<CourseView />} />
                <Route path="cart" element={<Cart />} />
                <Route path="my-courses" element={<UserCourses />} />
                <Route path="profile" element={<Profile />} />
                <Route path="communications" element={<FetchMessages />} />
                <Route path="notifications" element={<Notifications />} />
            </Route>

            {/* FALLBACK */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
